import { render, staticRenderFns } from "./UploadNewItemDropArea.vue?vue&type=template&id=41af4f59&scoped=true"
import script from "./UploadNewItemDropArea.vue?vue&type=script&lang=js"
export * from "./UploadNewItemDropArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af4f59",
  null
  
)

export default component.exports